import { Box, Button } from "@mui/material";
import { LoadingButton } from '@mui/lab';
import {toSnakeCase, getTextFromChildren} from "../utils/general_utils";

export default function PageButtonBlack(props) {

    const fs = props.fs ? props.fs : "14px";
    const pad = props.pad ? props.pad : "8px 16px";
    const width = props.width ? props.width : '300px';
    const icon = props.icon ? props.icon : '';
    const childText = getTextFromChildren(props.children);

    const bgColor = props.loading || props.disabled ? '#FFF' : '#003B8D';
    const border = props.loading || props.disabled ? "2px solid rgba(0, 59, 141, 0.30)" : '2px solid #003B8D';
    const color = props.loading  || props.disabled ? "rgba(0, 59, 141, 0.30)" : '#FFF';
    return (
        <Box sx={{width: width, display: 'block', margin:'auto'}}>
        {props.onClick ? 
        <Button test_id={toSnakeCase(childText)} onClick={props.onClick} startIcon={icon} disabled={props.loading || props.disabled} sx={{border: border,textTransform: 'none', minWidth: width, width: width , backgroundColor: bgColor, borderRadius: '4px', color: color, fontSize: fs, padding: pad, lineHeight: '28px', fontWeight: '500', margin: 'auto'}}>
            { props.children}
        </Button> 
        :
        <LoadingButton test_id={toSnakeCase(childText)} type="submit"  form={props.form} startIcon={icon} loading={props.loading}  disabled={props.disabled}  sx={{border: border, textTransform: 'none', opacity: props.loading ? 0.7 : 1, minWidth: width, width: width, backgroundColor: bgColor, borderRadius: '4px', color: color, fontSize: fs, padding: pad, lineHeight: '28px', fontWeight: '500', margin: 'auto'}}>
            {props.children}
        </LoadingButton>}
        </Box>

       

    );
}











